import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="portal"
export default class extends Controller {
  static values = { target: String, frame: String };

  connect() {
    if (this.hasFrameValue) {
      this.element.querySelectorAll("a").forEach((link) => {
        link.setAttribute("data-turbo-frame", this.frameValue);
      });
    }

    const destination = document.querySelector(this.targetValue);
    if (destination && this.element.parentElement !== destination) {
      destination.replaceChildren(this.element);
    }
  }
}
